import React from 'react'
import { Card, CardBody } from 'reactstrap'

// Location mapping rules now live in the admin portal as pre-processing rules.
// This stands in for LocationMappingRules / LocationMappingRuleEditor, which are
// kept in the tree behind SHOW_LEGACY_LOCATION_MAPPING in index.jsx rather than
// deleted, so the old screen can be brought back by flipping that one flag.
const LocationMappingRulesMoved = () => (
    <Card className='p-3'>
        <CardBody className="p-0">
            <div style={{ textAlign: 'center', padding: '40px' }}>
                <i
                    className="fas fa-arrow-circle-right mb-3"
                    style={{ fontSize: '32px', color: '#EE5A29' }}
                ></i>
                <h6 className="mb-0">
                    Location mapping rules have been ported and moved to admin portal pre processing rules
                </h6>
            </div>
        </CardBody>
    </Card>
)

export default LocationMappingRulesMoved
